import React from "react";
import { Empty, Spin, Card, Tag } from "antd";
import {
  CalendarOutlined,
  EnvironmentOutlined,
  DollarOutlined,
} from "@ant-design/icons";
import styled from "styled-components";
import EventCard from "./EventCard";

const EventsContainer = styled.div`
  margin-top: 20px;
`;

const EventsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 20px;
  margin-top: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  background-color: #fafafa;
  border-radius: 8px;
  margin-top: 20px;
`;

const EmptyText = styled.p`
  color: #666;
  font-size: 16px;
  margin-top: 15px;
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px;
`;

const EventsList = ({ events, loading, onRefresh }) => {
  if (loading) {
    return (
      <LoadingContainer>
        <Spin size="large" tip="Loading events..." />
      </LoadingContainer>
    );
  }

  if (!events || events.length === 0) {
    return (
      <EmptyState>
        <Empty
          description={
            <EmptyText>
              No events found. Create your first event to get started!
            </EmptyText>
          }
        />
      </EmptyState>
    );
  }

  return (
    <EventsContainer>
      <EventsGrid>
        {events.map((event) => (
          <EventCard
            key={event.id}
            event={event}
            onRefresh={onRefresh}
          />
        ))}
      </EventsGrid>
    </EventsContainer>
  );
};

export default EventsList;